import { gsap } from 'gsap'

export const title = (target) => {
  var tl = gsap.timeline()
  tl.to(target, { topOneValue: 0, duration: 0.7, ease: 'back.out(1.7)' })
  tl.to(target, { topTwoValue: 0, duration: 0.7, ease: 'back.out(1.7)' }, '-=0.5')
  tl.to(target, { pTransform: 0, paragraphOpacity: 1, translateY: 0, duration: 0.7, ease: 'power2.out' }, '-=0.5')
  return tl
}
export const button = (target) => {
  var tl = gsap.timeline()
  tl.to(target, { buttonOpacity: 1, translateY: 0, duration: 1, ease: 'power2.out' })
  return tl
}
export const setTitle = (target) => {
  var tl = gsap.timeline()
  tl.set(target, { buttonOpacity: 0, topOneValue: 112, topTwoValue: 112, paragraphOpacity: 0 })
  return tl
}
export const setParagraph = (target) => {
  var tl = gsap.timeline()
  tl.set(target, { pTransform: 112 })
  return tl
}
